require('react-select/dist/react-select.min.css');
require('./dropdownPlans.scss');

const PropTypes = require('prop-types');

const React = require('react');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { formatText } = require('core/i18n').i18n;
const classnames = require('classnames');
const PlanItemSelected = require('./planItemSelected');
const PlanItemOptions = require('./planItemOptions');
const { toCamelCase } = require('utilities/stringHelper');

class DropdownPlans extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        const { initialPlanId, currentPlanId } = this.props;
        if (initialPlanId && !currentPlanId) {
            this.props.onPlanChange(initialPlanId, true);
        }
    }

    handleChange(item) {
        this.props.onPlanChange(item.value);
    }

    render() {
        const { 
            immPlans, 
            currentPlanId, 
            enabled, 
            id, 
            isOriginPlan, 
            error, 
            errorMsg, 
            label, 
            tooltipMsg 
        } = this.props;
        const placeholder = formatText('brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step1SelectPlanB');
        const searchable = false;
        const clearable = false;
        let options = immPlans.map(immPlan => {
            const plan = immPlan.toJS();
            const dgsCode = plan.comercialData ? plan.comercialData.DGSCode : undefined;
            return {
                id,
                value: plan.internalId,
                name: toCamelCase(plan.name || ''),
                totalValue: plan.totalValueEur.amount,
                totalValueCurrency: plan.totalValueEur.currency,
                contract: plan.contractNumber,
                dgsCode: dgsCode,
                isOrigin: isOriginPlan
            };
        });

        options = Array.from(options.toJS());

        const className = classnames('dropdown-plans', { 'dropdown-plans--error': error });

        return (
            <OKSelect
                id={id}
                label={label}
                name="form-field-name"
                className={className}
                disabled={!enabled}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                optionComponent={PlanItemOptions}
                options={options}
                value={currentPlanId}
                valueComponent={PlanItemSelected}
                searchable={searchable}
                clearable={clearable}
                placeholder={placeholder}
                errorState={error}
                errorMessage={errorMsg}
                tooltipMsg={tooltipMsg}
            />
        );
    }
}

DropdownPlans.propTypes = {
    currentPlanId: PropTypes.string,
    enabled: PropTypes.bool,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
    filterId: PropTypes.string,
    id: PropTypes.string,
    immPlans: PropTypes.object,
    initialPlanId: PropTypes.string,
    isOriginPlan: PropTypes.bool,
    label: PropTypes.string,
    onPlanChange: PropTypes.func,
    planIndexes: PropTypes.array,
    tooltipMsg: PropTypes.string
};

DropdownPlans.defaultProps = {
    filterId: '',
    enabled: true,
    errorMsg: '',
    label: ''
};
module.exports = DropdownPlans;